export const SET_FLASH_MESSAGE = "SET_FLASH_MESSAGE";

export const setFlashMessage = (message) => (dispatch) =>
  dispatch({
    type: SET_FLASH_MESSAGE,
    message,
  });
